import { select } from 'redux-saga/effects';
import { getFeatureValue } from '../../selectors/featureSelectors';

/**
 * Helper function to check feature flags in sagas
 * @param {string} key - The feature flag key to check
 * @returns {boolean} - Whether the feature flag is enabled
 */
export function* checkFeatureFlag(key) {
  return yield select(state => getFeatureValue(state, { key }));
} 